<pk-web-navbar></pk-web-navbar>

<router-outlet></router-outlet>

<pk-web-footer></pk-web-footer>

<div id="top-of-site-pixel-anchor"></div>
